import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Avatar } from "../components/Avatar";
import { Loader } from "../components/ui-bits";
import { ArrowLeft, Send } from "lucide-react";

export default function Conversation() {
  const { cid } = useParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [text, setText] = useState("");
  const endRef = useRef();

  const load = () => api.get(`/conversations/${cid}/messages`).then((r) => setData(r.data));
  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [cid]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [data]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    const val = text; setText("");
    const optimistic = { id: `tmp-${Date.now()}`, sender_id: user.id, text: val, created_at: new Date().toISOString() };
    setData((d) => ({ ...d, messages: [...d.messages, optimistic] }));
    await api.post(`/conversations/${cid}/messages`, { text: val });
    load();
  };

  if (!data) return <Loader />;

  return (
    <div className="max-w-2xl mx-auto flex flex-col" style={{ height: "calc(100vh - 220px)" }}>
      <div className="flex items-center gap-3 pb-4 border-b border-zinc-800">
        <button onClick={() => nav("/app/messages")} className="p-1 text-zinc-400 hover:text-white" data-testid="back-to-messages"><ArrowLeft size={20} /></button>
        <Avatar user={data.other} size={40} />
        <div>
          <p className="font-semibold">@{data.other?.pseudo}</p>
          <p className="text-xs text-zinc-500 capitalize">{data.other?.role}</p>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto py-4 space-y-3">
        {data.messages.map((m) => {
          const mine = m.sender_id === user.id;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[75%] px-4 py-2.5 rounded-2xl text-sm ${mine ? "bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-br-md" : "bg-zinc-800 text-zinc-100 rounded-bl-md"}`}>
                {m.text}
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>

      <form onSubmit={send} className="flex items-center gap-2 pt-3 border-t border-zinc-800">
        <input data-testid="message-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Écris un message…"
          className="flex-1 bg-zinc-900 border border-zinc-700 rounded-full px-4 py-3 text-sm focus:border-violet-500 outline-none" />
        <button type="submit" data-testid="chat-send-message-button" className="w-12 h-12 rounded-full bg-gradient-to-r from-violet-600 to-purple-600 flex items-center justify-center shrink-0 hover:scale-105 transition-transform">
          <Send size={18} />
        </button>
      </form>
    </div>
  );
}
